import dynamic from 'next/dynamic';
export default {
  passwordreset: dynamic(() => import( /* webpackChunkName: "blazePbPasswordReset" */'./PasswordReset')),
  passwordresetrequest: dynamic(() => import( /* webpackChunkName: "blazePbPasswordResetRequest" */'./PasswordResetRequest'))
};
//# sourceMappingURL=index.js.map